import React from "react";

function formatDateTime(timestamp) {
  if (!timestamp) return "-";

  try {
    return new Date(timestamp).toLocaleString("tr-TR");
  } catch (error) {
    return String(timestamp);
  }
}

function getTaskTitle(task) {
  switch (task?.type) {
    case "updatePoint":
      return `Nokta güncellemesi (${task.pointId || "-"})`;
    case "updateTeam":
      return `Takım güncellemesi (${task.teamId || "-"})`;
    case "updatePafta":
      return `Pafta güncellemesi (${task.paftaId || "-"})`;
    case "renameProject":
      return `Proje adı değişikliği (${task.projectId || "-"})`;
    case "updateProjectTemplate":
      return `Ölçüm şablonu güncellemesi (${task.projectId || "-"})`;
    case "deletePafta":
      return `Pafta silme (${task.paftaId || "-"})`;
    case "deleteTeam":
      return `Takım silme (${task.teamId || "-"})`;
    case "deleteProject":
      return `Proje silme (${task.projectId || "-"})`;
    default:
      return task?.type || "Bilinmeyen işlem";
  }
}

function getLocalPayload(task) {
  if (!task) return {};

  if (task.type === "updatePoint" || task.type === "updatePafta") {
    return task.updates || {};
  }

  if (task.type === "renameProject") {
    return task.data || {};
  }

  if (task.type === "updateTeam" || task.type === "updateProjectTemplate") {
    return task.data || {};
  }

  return task;
}

function getServerPayload(conflict) {
  return conflict?.current || {};
}

function prettyJson(value) {
  try {
    return JSON.stringify(value, null, 2);
  } catch (error) {
    return String(value);
  }
}

export default function SyncConflictPanel({
  open,
  onClose,
  conflicts,
  pendingCount,
  isOnline,
  onUseServer,
  onUseLocal,
  onDismiss,
  onDismissAll,
}) {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15, 23, 42, 0.45)",
        zIndex: 12000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
      onClick={onClose}
    >
      <div
        onClick={(event) => event.stopPropagation()}
        style={{
          width: "min(980px, 100%)",
          maxHeight: "90vh",
          overflow: "auto",
          background: "#ffffff",
          borderRadius: 18,
          boxShadow: "0 30px 70px rgba(15, 23, 42, 0.28)",
          padding: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 12,
            marginBottom: 16,
          }}
        >
          <div>
            <h2 style={{ margin: 0, fontSize: "1.15rem", color: "#0f172a" }}>
              Senkron Çakışmaları
            </h2>
            <p style={{ margin: "6px 0 0", color: "#475569", fontSize: "0.92rem" }}>
              Aynı kayıt hem yerelde hem sunucuda değiştiyse burada karar verilir.
            </p>
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
            {conflicts.length > 0 ? (
              <button
                type="button"
                onClick={onDismissAll}
                style={{
                  border: "1px solid #fecaca",
                  background: "#fff1f2",
                  color: "#991b1b",
                  borderRadius: 10,
                  padding: "8px 12px",
                  cursor: "pointer",
                  fontWeight: 700,
                }}
              >
                Tümünü listeden kaldır
              </button>
            ) : null}
            <button
              type="button"
              onClick={onClose}
              style={{
                border: "none",
                background: "#e2e8f0",
                color: "#0f172a",
                borderRadius: 10,
                padding: "8px 12px",
                cursor: "pointer",
                fontWeight: 700,
              }}
            >
              Kapat
            </button>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: 10,
            flexWrap: "wrap",
            marginBottom: 16,
          }}
        >
          <span
            style={{
              background: "#fee2e2",
              color: "#991b1b",
              borderRadius: 999,
              padding: "6px 12px",
              fontWeight: 700,
              fontSize: "0.84rem",
            }}
          >
            Çakışma: {conflicts.length}
          </span>
          <span
            style={{
              background: "#dbeafe",
              color: "#1d4ed8",
              borderRadius: 999,
              padding: "6px 12px",
              fontWeight: 700,
              fontSize: "0.84rem",
            }}
          >
            Bekleyen işlem: {pendingCount}
          </span>
          <span
            style={{
              background: isOnline ? "#dcfce7" : "#fde68a",
              color: isOnline ? "#166534" : "#92400e",
              borderRadius: 999,
              padding: "6px 12px",
              fontWeight: 700,
              fontSize: "0.84rem",
            }}
          >
            {isOnline ? "Bağlantı var" : "Çevrimdışı"}
          </span>
        </div>

        {!conflicts.length ? (
          <div
            style={{
              padding: 24,
              textAlign: "center",
              color: "#475569",
              border: "1px dashed #cbd5e1",
              borderRadius: 14,
            }}
          >
            Aktif çakışma yok.
          </div>
        ) : null}

        {conflicts.map((conflict, index) => (
          <div
            key={`${conflict.createdAt || index}_${index}`}
            style={{
              border: "1px solid #e2e8f0",
              borderRadius: 16,
              padding: 16,
              marginBottom: 14,
              background: "#f8fafc",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 12,
                marginBottom: 12,
              }}
            >
              <div>
                <div style={{ fontWeight: 800, color: "#0f172a", marginBottom: 4 }}>
                  {getTaskTitle(conflict.task)}
                </div>
                <div style={{ fontSize: "0.84rem", color: "#64748b" }}>
                  Çakışma zamanı: {formatDateTime(conflict.createdAt)}
                </div>
              </div>
              <div
                style={{
                  background: "#fff7ed",
                  color: "#9a3412",
                  borderRadius: 10,
                  padding: "6px 10px",
                  fontSize: "0.8rem",
                  fontWeight: 700,
                }}
              >
                Çakışma algılandı
              </div>
            </div>

            <div style={{ color: "#334155", marginBottom: 12 }}>{conflict.message}</div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
                gap: 12,
              }}
            >
              <div>
                <div style={{ fontWeight: 700, marginBottom: 8, color: "#0f172a" }}>
                  Yerelde bekleyen değişiklik
                </div>
                <pre
                  style={{
                    margin: 0,
                    background: "#0f172a",
                    color: "#e2e8f0",
                    borderRadius: 12,
                    padding: 12,
                    overflow: "auto",
                    fontSize: "0.78rem",
                    lineHeight: 1.45,
                  }}
                >
                  {prettyJson(getLocalPayload(conflict.task))}
                </pre>
              </div>

              <div>
                <div style={{ fontWeight: 700, marginBottom: 8, color: "#0f172a" }}>
                  Sunucudaki güncel kayıt
                </div>
                <pre
                  style={{
                    margin: 0,
                    background: "#fff",
                    color: "#0f172a",
                    border: "1px solid #cbd5e1",
                    borderRadius: 12,
                    padding: 12,
                    overflow: "auto",
                    fontSize: "0.78rem",
                    lineHeight: 1.45,
                  }}
                >
                  {prettyJson(getServerPayload(conflict))}
                </pre>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: 10,
                flexWrap: "wrap",
                marginTop: 14,
              }}
            >
              <button
                type="button"
                onClick={() => onUseServer(conflict, index)}
                style={{
                  border: "none",
                  background: "#0f766e",
                  color: "#fff",
                  borderRadius: 10,
                  padding: "10px 14px",
                  cursor: "pointer",
                  fontWeight: 700,
                }}
              >
                Sunucudaki sürümü al
              </button>
              <button
                type="button"
                onClick={() => onUseLocal(conflict, index)}
                style={{
                  border: "none",
                  background: "#b45309",
                  color: "#fff",
                  borderRadius: 10,
                  padding: "10px 14px",
                  cursor: "pointer",
                  fontWeight: 700,
                }}
              >
                Yerel değişikliği yeniden uygula
              </button>
              <button
                type="button"
                onClick={() => onDismiss(conflict, index)}
                style={{
                  border: "1px solid #cbd5e1",
                  background: "#fff",
                  color: "#334155",
                  borderRadius: 10,
                  padding: "10px 14px",
                  cursor: "pointer",
                  fontWeight: 700,
                }}
              >
                Listeden kaldır
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
